// @helpers
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const {
    BROKER_STOCKS_SEARCH_PAGE_NUM,
    BROKER_STOCKS_SEARCH_PAGE_SIZE,
    BROKER_STOCKS_TYPE_FOOTBALL,
    BROKER_FOOTBALL_STOCK_QUERY_TYPE,
    BROKER_SOCIAL_MEDIA_STOCK_QUERY_TYPE
} = require('constants/brokerKnowTheseStocks');
const { BROKER_TICKER_SCREEN } = require('constants/index');

const stockDetailsFetchStart = (stockType) => ({
    type: actionTypes.BROKER_KNOW_THESE_STOCKS_FETCHING,
    payload: { stockType }
});

const stockDetailSuccess = (response, stockType) => ({
    type: actionTypes.BROKER_KNOW_THESE_STOCKS_SUCCESS,
    payload: { stockType, response }
});

const stockDetailFailure = (error, stockType) => ({
    type: actionTypes.BROKER_KNOW_THESE_STOCKS_FAILURE,
    payload: { stockType, error }
});

const getStocksDetails = (stockType) => (dispatch) => {
    dispatch(stockDetailsFetchStart(stockType));

    const specType = (stockType === BROKER_STOCKS_TYPE_FOOTBALL) ? BROKER_FOOTBALL_STOCK_QUERY_TYPE : BROKER_SOCIAL_MEDIA_STOCK_QUERY_TYPE ;

    const requestData = {
        query: {
            pageNum: BROKER_STOCKS_SEARCH_PAGE_NUM,
            pageSize: BROKER_STOCKS_SEARCH_PAGE_SIZE,
            spcSymbol: specType,
            exchangeId: 0,
            screen: BROKER_TICKER_SCREEN
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('exchangeIndexes'), requestData)
        .then(response => {
            dispatch(stockDetailSuccess(response, stockType));
        }, response => {
            dispatch(stockDetailFailure(response, stockType));
        }
    );

}

module.exports = {
    getStocksDetails
}
